import { Kosik } from "../class/Kosik.js";
import { KonfiguraceZbrane as KF } from "../class/KonfiguraceZbrane.js";

export function resetKosiku() {
  Lc.f("kosikStr:resetKosiku");
  Kosik.smazVse();
  KF.smazVse();
}

export function upravStrankuKosiku() {
  Lc.log("-stranka kosiku");
  //----------- zachyceni udalosti pro samzani v kosiku
  //---udalost pro pridani produktu do kosiku je v detail.js
  Kosik.loadEventsForDeleteInCart();
}
